import './App.css';
import HomePage from './pages/HomePage';
import DownloadPage from './pages/DownloadPage';
import VotePage from './pages/VotePage';
import StorePage from './pages/StorePage';
import HiscoresPage from './pages/HiscoresPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ContactPage from './pages/ContactPage';
import { Route, Switch } from 'react-router-dom';

function App() {
  return (
    <div>
      <Switch>
        <Route path="/hiscores/boss-hiscores" exact component={HiscoresPage} />
        <Route path="/hiscores" exact component={HiscoresPage} />
        <Route path="/vote/:username" exact component={VotePage} />
        <Route path="/vote" exact component={VotePage} />
        <Route path="/store" exact component={StorePage} />
        <Route path="/play" exact component={DownloadPage} />
        <Route path="/terms" exact component={TermsPage} />
        <Route path="/privacy" exact component={PrivacyPage} />
        <Route path="/contact" exact component={ContactPage} />
        <Route path="/" component={HomePage} />
      </Switch>
    </div>
  );
}

export default App;
